export default __webpack_public_path__ + "static/media/logo.5613f2ac.png";